import { ImportData } from '../import-data';

export class ImportMappingsPayload {
  mappings: ImportData[];
  hash: string;
}
